import { IEditorV3 } from "../classes/interface";

/**
 * Converts a plain string to EditorV3 content structure.
 * Splits the string by line breaks and creates text blocks for each line, removing undesirable non-printing characters.
 *
 * @param value - The plain string to convert to EditorV3 content
 * @returns An IEditorV3 object representing the string content
 */
export const stringToV3 = (value: string): IEditorV3 => {
  return {
    lines: value
      .replace(/[\u2009-\u200f\r\t]/g, "") // Undesirable non-printing chars
      .split(/\n/)
      .map((line) => ({ textBlocks: [{ text: line, type: "text" }] })),
  };
};
